import React from 'react';

/**
 * NoteCard — Compact preview card for notes list.
 */
export default function NoteCard({ note, onClick, onDelete, isActive }) {
    const preview = note.plainText
        ? note.plainText.length > 120
            ? note.plainText.slice(0, 120) + '...'
            : note.plainText
        : 'Empty note';

    const timeAgo = (dateStr) => {
        if (!dateStr) return '';
        const diff = Date.now() - new Date(dateStr).getTime();
        const mins = Math.floor(diff / 60000);
        if (mins < 1) return 'just now';
        if (mins < 60) return `${mins}m ago`;
        const hrs = Math.floor(mins / 60);
        if (hrs < 24) return `${hrs}h ago`;
        const days = Math.floor(hrs / 24);
        if (days < 7) return `${days}d ago`;
        return new Date(dateStr).toLocaleDateString();
    };

    return (
        <div
            className={`notes-card ${isActive ? 'notes-card--active' : ''}`}
            onClick={() => onClick(note._id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onClick(note._id)}
        >
            <div className="notes-card-header">
                <h4 className="notes-card-title">{note.title || 'Untitled Note'}</h4>
                {onDelete && (
                    <button
                        className="notes-card-delete"
                        onClick={(e) => { e.stopPropagation(); onDelete(note._id); }}
                        aria-label="Delete note"
                        title="Delete"
                    >
                        &times;
                    </button>
                )}
            </div>

            <p className="notes-card-preview">{preview}</p>

            <div className="notes-card-meta">
                <span className="notes-card-time">{timeAgo(note.updatedAt)}</span>
                {note.metadata?.wordCount > 0 && (
                    <span className="notes-card-words">{note.metadata.wordCount} words</span>
                )}
                {note.source === 'ai-generated' && (
                    <span className="notes-card-ai-badge">AI</span>
                )}
            </div>

            {(note.companyIds?.length > 0 || note.tags?.length > 0) && (
                <div className="notes-card-tags">
                    {note.companyIds?.map(c => (
                        <span key={c} className="notes-card-company">{c}</span>
                    ))}
                    {note.tags?.map(t => (
                        <span key={t} className="notes-card-tag">#{t}</span>
                    ))}
                </div>
            )}
        </div>
    );
}
